const DETAILS_SELECTOR = '[data-reason-details]'
const OPTION_SELECTOR = '[data-reason-option]'
const LABEL_SELECTOR = '[data-reason-label]'
const VALUE_SELECTOR = '[data-reason-value]'

class ReasonSelect extends HTMLElement {
  #details = null

  #onKeydown = (event) => {
    if (event.key !== 'Escape') return
    const details = this.#details
    if (!(details instanceof HTMLDetailsElement)) return
    if (!details.open) return

    details.open = false
    details.querySelector('summary')?.focus()
  }

  #onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null
    const option = target?.closest(OPTION_SELECTOR)
    if (!option) return

    this.#select(option.getAttribute('value') ?? '')
  }

  connectedCallback() {
    this.#details = this.querySelector(DETAILS_SELECTOR)
    this.addEventListener('click', this.#onClick)
    this.addEventListener('keydown', this.#onKeydown)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick)
    this.removeEventListener('keydown', this.#onKeydown)
  }

  /** @param {string} value */
  #select(value) {
    const label = this.querySelector(LABEL_SELECTOR)
    const field = this.querySelector(VALUE_SELECTOR)

    if (label) label.textContent = value
    if (field instanceof HTMLInputElement) field.value = value
    if (this.#details instanceof HTMLDetailsElement) this.#details.open = false
  }
}

customElements.define('reason-select', ReasonSelect)
